import React from 'react';
import Lightbox from 'react-images';

import styles from '../../styles/componentStyle/light-box-image.scss';

const customStyles = {
  view: base => ({
    ...base,
    width: 600,
    height: 600,
  }),
};

export class LightBoxImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLightBoxOpen: false,
      selectedImages: [],
    };
  }

  componentDidMount() {
    this.setState({
      selectedImages: [{ src: this.props.imageUrl }],
    });
  }

  handleThumbnailClick = () => {
    this.setState({
      selectedImages: [{ src: this.props.imageUrl }],
      isLightBoxOpen: true,
    });
  };

  handleCloseLightbox = () => {
    this.setState({
      isLightBoxOpen: false,
      selectedImages: [],
    });
  };

  render() {
    return (
      <React.Fragment>
        <div
          onClick={!this.props.disabled && this.handleThumbnailClick}
          className={
            this.props.disabled
              ? styles['light-box-image--disabled']
              : styles['light-box-image']
          }
        >
          <img src={this.props.imageUrl} alt='Instruction' />
        </div>
        <Lightbox
          styles={customStyles}
          images={this.state.selectedImages}
          preventScroll={false}
          isOpen={this.state.isLightBoxOpen}
          onClose={this.handleCloseLightbox}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/image/LightBoxImage.jsx